module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Assignment Detail")]), _vm._v(" "), (_vm.PMC_itemDet.JOBNO) ? _c('span', [_vm._v("\n      JOBNO. :" + _vm._s(_vm.PMC_itemDet.JOBNO) + "\n      "), _c('br'), _vm._v("\n      JOB Date :" + _vm._s(_vm.PMC_itemDet.JOBDate) + "\n      "), _c('br'), _vm._v("\n      JOB Type :" + _vm._s(_vm.PMC_itemDet.JOBTYPE) + "\n      "), _c('br'), _vm._v("\n      Client :" + _vm._s(_vm.PMC_itemDet.clientName) + "\n      "), _c('br'), _vm._v("\n      SLine :" + _vm._s(_vm.PMC_itemDet.shippingLine) + "\n      "), _c('br'), _vm._v("\n      Branch :" + _vm._s(_vm.PMC_itemDet.Branch) + "\n      "), _c('br'), _vm._v("\n      Job Created By :" + _vm._s(_vm.PMC_itemDet.RaisedBy) + "\n      "), _c('br'), _vm._v("\n      Shipment Type :" + _vm._s(_vm.PMC_itemDet.shipmentType) + "\n      "), _c('br'), _vm._v("\n      Transport Type :" + _vm._s(_vm.PMC_itemDet.transportType) + "\n      "), _c('br'), _vm._v("\n      Job Status :" + _vm._s(_vm.PMC_itemDet.JOBStatus) + "\n      "), _c('br'), _vm._v("\n      Billing Status :" + _vm._s(_vm.PMC_itemDet.finalBillingCompletedStatus) + "\n      "), _c('br'), _vm._v("\n      Manifestation Date :" + _vm._s(_vm.PMC_itemDet.manifestDate) + "\n      "), _c('br'), _vm._v("\n      Note Details :\n      "), (_vm.PMC_itemDet.NoteSeries) ? _c('div', _vm._l((_vm.PMC_itemDet.NoteSeries.split(',')), function(item1, index) {
    return _c('span', {
      key: index
    }, [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + " ")])], 1)])
  })) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.PMC_itemDet.assignmentCloseReason) ? _c('b', {
    staticStyle: {
      "color": "green"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.truncateHTML(_vm.PMC_itemDet.assignmentCloseReason, 50))
    }
  }, [_vm._v("Close Reason :" + _vm._s(_vm.PMC_itemDet.assignmentCloseReason))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n      Manifestation Status :" + _vm._s(_vm.PMC_itemDet.is_maniFestSend) + "\n      "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Pushed to Billing Desk")]), _vm._v(" "), (
    _vm.PMC_itemDet.FFCreatedDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
  ) ? _c('span', [_vm._v("\n      FF Req CD. :" + _vm._s(_vm.PMC_itemDet.FFCreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.FFCUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
  ) ? _c('span', [_vm._v("\n      FF Req CB. :" + _vm._s(_vm.PMC_itemDet.FFCUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.FFUpdateDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
  ) ? _c('span', [_vm._v("\n      FF Req UD. :" + _vm._s(_vm.PMC_itemDet.FFUpdateDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.FFUUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
  ) ? _c('span', [_vm._v("\n      FF Req UB. :" + _vm._s(_vm.PMC_itemDet.FFUUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.FFUUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
  ) ? _c('hr') : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.CCCreatedDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
  ) ? _c('span', [_vm._v("\n      CC Req CD. :" + _vm._s(_vm.PMC_itemDet.CCCreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.CCCUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
  ) ? _c('span', [_vm._v("\n      CC Req CB. :" + _vm._s(_vm.PMC_itemDet.CCCUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.CCUpdateDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
  ) ? _c('span', [_vm._v("\n      CC Req UD. :" + _vm._s(_vm.PMC_itemDet.CCUpdateDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.CCUUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
  ) ? _c('span', [_vm._v("\n      CC Req UB. :" + _vm._s(_vm.PMC_itemDet.CCUUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.CCUUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
  ) ? _c('hr') : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.TPTCreatedDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
  ) ? _c('span', [_vm._v("\n      TPT Req CD. :" + _vm._s(_vm.PMC_itemDet.TPTCreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.TPTCreatedDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
  ) ? _c('span', [_vm._v("\n      TPT Req CB. :" + _vm._s(_vm.PMC_itemDet.TPTCUserName) + " "), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.TPTUpdateDate &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
  ) ? _c('span', [_vm._v("\n      TPT Req UD. :" + _vm._s(_vm.PMC_itemDet.TPTUpdateDate)), _c('br')]) : _vm._e(), _vm._v(" "), (
    _vm.PMC_itemDet.TPTUUserName &&
    _vm.PMC_itemDet.isMiscJob == '0' &&
    _vm.PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
  ) ? _c('span', [_vm._v("\n      TPT Req UB. :" + _vm._s(_vm.PMC_itemDet.TPTUUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.MISCCreatedDate && _vm.PMC_itemDet.isMiscJob == '1') ? _c('span', [_vm._v("\n      MISC Req CD. :" + _vm._s(_vm.PMC_itemDet.MISCCreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.TBMISCCUserName && _vm.PMC_itemDet.isMiscJob == '1') ? _c('span', [_vm._v("\n      MISC Req CB. :" + _vm._s(_vm.PMC_itemDet.TBMISCCUserName)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.MISCUpdateDate && _vm.PMC_itemDet.isMiscJob == '1') ? _c('span', [_vm._v("\n      MISC Req UD. :" + _vm._s(_vm.PMC_itemDet.MISCUpdateDate)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.TBMISCUUserName && _vm.PMC_itemDet.isMiscJob == '1') ? _c('span', [_vm._v("\n      MISC Req UB. :" + _vm._s(_vm.PMC_itemDet.TBMISCUUserName) + " "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "delay"
  }, [_vm._v("Delay"), _c('br'), _vm._v(" "), (_vm.PMC_itemDet.ff_tall_diff && _vm.PMC_itemDet.isMiscJob == '0') ? _c('span', [_vm._v("FF:" + _vm._s(_vm.PMC_itemDet.ff_tall_diff)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.cc_tall_diff && _vm.PMC_itemDet.isMiscJob == '0') ? _c('span', [_vm._v("CC:" + _vm._s(_vm.PMC_itemDet.cc_tall_diff)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.tpt_tall_diff && _vm.PMC_itemDet.isMiscJob == '0') ? _c('span', [_vm._v("TPT:" + _vm._s(_vm.PMC_itemDet.tpt_tall_diff)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.PMC_itemDet.misc_tall_diff && _vm.PMC_itemDet.isMiscJob == '1') ? _c('span', [_vm._v("MISC:" + _vm._s(_vm.PMC_itemDet.misc_tall_diff))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Pushed to Tally")]), _vm._v(" "), (_vm.PMC_itemDet.TallyBillingSeriesUsers) ? _c('div', [_vm._l((_vm.PMC_itemDet.TallyBillingSeriesUsers.split(',')), function(item1, index) {
    return _c('span', {
      key: index
    }, [_vm._l((item1.split(' - ')), function(item2, index2) {
      return _c('h6', {
        key: index2
      }, [_c('b-badge', [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)
    }), _c('hr')], 2)
  }), _c('br')], 2) : _c('span', [_vm._v("-----------")])]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "card status"
  }, [_c('h6', [_vm._v("Difference Reverse")]), _vm._v(" "), (_vm.PMC_itemDet.TallyBillingSeriesWithLoginTimeAndDocDtlsNo) ? _c('div', [_vm._l((_vm.PMC_itemDet.TallyBillingSeriesWithLoginTimeAndDocDtlsNo.split(',')), function(item1, index) {
    return _c('span', {
      key: index
    }, _vm._l((item1.split(' | ')), function(item2, index2) {
      return _c('h6', {
        key: index2
      }, [_c('b-badge', {
        attrs: {
          "variant": _vm.pattern.test(item2) ? 'danger' : 'primary'
        }
      }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)
    }))
  }), _c('br')], 2) : _c('span', [_vm._v("-----------")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.PMC_itemDet.RevBillingSeries) ? _c('div', _vm._l((_vm.PMC_itemDet.RevBillingSeries.split(',')), function(item1, index) {
    return _c('span', {
      key: index
    }, [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + " ")])], 1)])
  })) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('departmentName').indexOf('Accounts') >= 0 || this.$sessionsStorage.get('designation') == 'Admin') ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.proceedBilling(
          _vm.PMC_itemDet.allModuleId,
          _vm.PMC_itemDet.newContainerFlow,
          _vm.PMC_itemDet.isConsolidation,
          _vm.PMC_itemDet.mainSalesSeries
        )
      }
    }
  }, [_vm._v(_vm._s(_vm.PMC_itemDet.finalBillingCompletedFlag == "1" ?
    "Show Billing" :
    "Proceed To Billing"))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7479abca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/billingInvCard.vue
// module id = 2750
// module chunks = 0